(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sm-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sm-project-gallery')) {
  customElements.define('sm-project-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.sm-gallery__track');
      this.allSlides = [...this.querySelectorAll('.sm-gallery__slide')];
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.sm-gallery__slide');
        if (slide) {
          slide.hidden = false;
          this.slides = this.allSlides.filter(item => !item.hidden);
          this.go(this.slides.indexOf(slide), false);
        }
      }, options);
      this.resize = new ResizeObserver(() => this.go(this.index || 0, false));
      this.resize.observe(this.track);
      this.reset();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    reset() {
      if (!this.allSlides) return;
      const seen = new Set();
      this.allSlides.forEach(slide => {
        const src = slide.querySelector('img')?.getAttribute('src') || '';
        const key = src.split('?')[0].split('/').pop();
        slide.hidden = !window.Shopify?.designMode && seen.has(key);
        seen.add(key);
      });
      this.slides = this.allSlides.filter(slide => !slide.hidden);
      this.slides.forEach((slide, index) => slide.setAttribute('aria-label', `${index + 1} / ${this.slides.length}`));
      this.querySelector('.sm-gallery__controls').hidden = this.slides.length < 2;
      this.go(0, false);
    }
    go(index, animate = true) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      this.querySelector('.sm-gallery__count').textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    update() {
      this.index = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
      this.querySelector('.sm-gallery__count').textContent = `${this.index + 1} / ${this.slides.length}`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-kit-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sm-kit-finder')) {
  customElements.define('sm-kit-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.words = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.index = 0;
      this.answers = {};
      this.started = false;
      this.resultKey = '';
      this.storageKey = 'sm-finder-v4-'+this.dataset.locale+'-'+this.dataset.section;
      const opts = {signal:this.abort.signal};
      this.querySelectorAll('[data-show-kit]').forEach(button=>button.addEventListener('click',()=>this.selectKit(button.dataset.showKit,true),opts));
      this.querySelector('[data-begin]').addEventListener('click',()=>this.begin(),opts);
      this.querySelectorAll('[data-reset]').forEach(b=>b.addEventListener('click',()=>this.reset(),opts));
      this.querySelector('[data-edit]').addEventListener('click',()=>{this.index=0;this.showStep();},opts);
      this.querySelector('[data-next]').addEventListener('click',()=>this.next(),opts);
      this.querySelector('[data-back]').addEventListener('click',()=>this.back(),opts);
      this.querySelectorAll('[data-field] input[type=radio]').forEach(input=>input.addEventListener('change',()=>{
        this.answers[input.name]=input.value;
        this.querySelector('[data-question-error]').hidden=true;
        if (input.name==='project') this.setMedia(this.answers.project);
        this.save();
      },opts));
      this.querySelectorAll('[data-kit]').forEach(card=>{
        const form=card.querySelector('form');
        if (!form) return;
        form.addEventListener('submit',event=>this.addToCart(event,card),opts);
        card.querySelector('[data-variant]').addEventListener('change',()=>this.syncVariant(card),opts);
        card.querySelector('[data-gift-color]')?.addEventListener('change',()=>{card.querySelector('[name=sm_gift_choice][value=color]').checked=true;},opts);
        this.syncVariant(card);
      });
      this.addEventListener('play',event=>{
        if (event.target.tagName==='VIDEO') this.querySelectorAll('video').forEach(video=>{if(video!==event.target)video.pause();});
      },{capture:true,signal:this.abort.signal});
      
      try {
        const saved=JSON.parse(sessionStorage.getItem(this.storageKey)||'null');
        if(saved && saved.version===4){
          for(const [key,value] of Object.entries(saved.answers||{})){
            const input=Array.from(this.querySelectorAll('input[type=radio]')).find(x=>x.name===key && x.value===value);
            if(input){input.checked=true;this.answers[key]=value;}
          }
          
          if(saved.started){this.started=true;this.index=this.path().includes(saved.index)?saved.index:0;this.showStep(false);}
          if(saved.result && this.isComplete()){this.showResult(false);if(saved.selectedKit)this.selectKit(saved.selectedKit);for(const [key,value] of Object.entries(saved.variants||{})){const card=Array.from(this.querySelectorAll('[data-kit]')).find(c=>c.dataset.kit===key);const select=card?.querySelector('[data-variant]');if(select && Array.from(select.options).some(o=>o.value===value)){select.value=value;this.syncVariant(card);}}}
        }
      }catch{}
      if(new URLSearchParams(location.search).has('contact_posted') || this.querySelector('#sf-contact-form .errors')){
        if(this.isComplete())this.showResult(false);
        else{this.querySelector('[data-intro]').hidden=true;this.querySelector('[data-result]').hidden=false;}
        this.querySelector('[data-contact]').open=true;
        this.querySelector('[data-contact]').scrollIntoView({block:'start'});
      }
      const returnField=this.querySelector('#sf-contact-form input[name=return_to]');if(returnField)returnField.value=location.pathname+location.search;
      this.dataset.ready='true';
    }
    disconnectedCallback(){this.abort?.abort();this.ready=false;}
    path(){return [0,1,2];}
    activeFields(index){return Array.from(this.querySelector(`[data-step="${index}"]`).querySelectorAll('[data-field]')).filter(f=>!f.hidden);}
    isComplete(){return this.path().every(i=>this.activeFields(i).every(f=>this.answers[f.dataset.field]));}
    begin(){this.started=true;this.index=0;this.track('start');this.showStep();}
    save(){try{sessionStorage.setItem(this.storageKey,JSON.stringify({version:4,answers:this.answers,index:this.index,started:this.started,result:!this.querySelector('[data-result]').hidden,selectedKit:this.resultKey,variants:Object.fromEntries(Array.from(this.querySelectorAll('[data-kit]')).filter(c=>c.querySelector('[data-variant]')).map(c=>[c.dataset.kit,c.querySelector('[data-variant]').value]))}));}catch{}}
    focus(element){element.focus({preventScroll:true});element.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    showStep(move=true){
      
      this.querySelector('[data-persistent-reset]').hidden=false;
      this.querySelectorAll('video').forEach(v=>v.pause());
      this.querySelector('[data-intro]').hidden=true;
      this.querySelector('[data-result]').hidden=true;
      this.querySelector('[data-workspace]').hidden=false;
      this.querySelectorAll('[data-step]').forEach(s=>s.hidden=Number(s.dataset.step)!==this.index);
      const path=this.path(),position=path.indexOf(this.index)+1;
      this.querySelector('[data-progress-label]').textContent=`${this.words.step} ${position} ${this.words.of} ${path.length}`;
      const progress=this.querySelector('progress');progress.max=path.length;progress.value=position;
      this.querySelector('[data-next]').textContent=position===path.length?this.words.finish_label:this.words.next;
      this.querySelector('[data-question-error]').hidden=true;
      this.setMedia(this.answers.project);
      this.save();
      this.track('step_view',{step:this.index+1});
      if(move)this.focus(this.querySelector(`[data-step="${this.index}"]`));
    }
    next(){
      const missing=this.activeFields(this.index).find(f=>!this.answers[f.dataset.field]);
      if(missing){this.querySelector('[data-question-error]').hidden=false;missing.querySelector('input').focus();return;}
      this.track('step_complete',{step:this.index+1});
      const path=this.path(),position=path.indexOf(this.index);
      if(position===path.length-1)this.showResult();
      else{this.index=path[position+1];this.showStep();}
    }
    back(){const p=this.path(),i=p.indexOf(this.index);if(i>0){this.index=p[i-1];this.showStep();}else{this.querySelector('[data-workspace]').hidden=true;this.querySelector('[data-intro]').hidden=false;this.querySelector('[data-begin]').focus();this.save();}}
    decide(){
      const a=this.answers,issues=[];
      if(a.size!=='small')issues.push('size');
      const key=a.project==='verticali'?'verticali':a.project==='scultura'?'scultura':'miniature';
      const mode=a.start==='mold'?'mold':a.project==='unknown'?'explore':'consider';
      return {key,issues,mode};
    }
    selectKit(key,move=false){
      const card=Array.from(this.querySelectorAll('[data-kit]')).find(c=>c.dataset.kit===key);
      if(!card)return;
      this.resultKey=key;
      if(this.recommendReason){this.querySelector('[data-result-reason]').textContent=key===this.decide().key?this.recommendReason:card.querySelector('.sm-rich').textContent;}
      this.querySelectorAll('[data-kit]').forEach(c=>c.hidden=c!==card);
      this.querySelectorAll('[data-show-kit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.showKit===key)));
      const result=this.decide();
      card.querySelector('[data-kit-badge]').textContent=this.words[key!==result.key?'alternative_label':result.mode+'_label'];
      const brief=this.querySelector('#sf-brief');
      if(this.briefLines)brief.value=this.briefLines.concat(this.words.brief_kit+': '+card.dataset.title).join('\n');
      const film=this.querySelector('[data-result-film]');film.querySelectorAll('video').forEach(v=>v.pause());film.replaceChildren();
      const heading=document.createElement('h3');heading.textContent=this.words.media_title;film.append(heading);
      const media=this.mediaTemplate(key);if(media)film.append(media.content.cloneNode(true));
      this.save();
      if(move){card.setAttribute('tabindex','-1');this.focus(card);this.track('kit_compare',{result:key});}
    }
    showResult(move=true){
      this.querySelector('[data-persistent-reset]').hidden=false;
      if(!this.isComplete())return;
      const result=this.decide();this.resultKey=result.key;
      this.querySelectorAll('video').forEach(v=>v.pause());
      this.querySelector('[data-intro]').hidden=true;
      this.querySelector('[data-workspace]').hidden=true;
      this.querySelector('[data-result]').hidden=false;
      this.querySelector('[data-result-title]').textContent=result.mode==='mold'?this.words.result_mold:result.mode==='explore'?this.words.result_explore:result.mode==='consider'?this.words.result_consider:this.words.result_heading;
      this.querySelector('[data-result-reason]').textContent=result.mode==='mold'?this.words.mold_note:result.mode==='explore'?this.words.unknown_note:result.key==='verticali'?this.words.vertical_note:result.key==='scultura'?this.words.reason_simple:this.words.reason_flexible;
      this.recommendReason=this.querySelector('[data-result-reason]').textContent;
      const advice=[];
      if(this.answers.start==='idea')advice.push(this.words.idea_note);
      for(const issue of result.issues)advice.push(issue==='casting'?this.words.casting_note:this.words['reason_'+issue]);
      this.querySelector('[data-project-advice]').hidden=!advice.length;
      this.querySelector('[data-advice-text]').textContent=advice.map(text=>text.charAt(0).toUpperCase()+text.slice(1)).join(' ');
      this.querySelectorAll('[data-kit]').forEach(c=>c.hidden=c.dataset.kit!==result.key);
      const summary=this.querySelector('[data-summary]');summary.replaceChildren();
      const lines=[];
      this.path().forEach(i=>this.activeFields(i).forEach(f=>{
        const label=f.querySelector('legend').textContent;
        const input=Array.from(f.querySelectorAll('input')).find(x=>x.value===this.answers[f.dataset.field]);
        const answer=input?.closest('label').querySelector('strong').textContent||'';
        const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=answer;summary.append(dt,dd);lines.push(`${label} ${answer}`);
      }));
      lines.push(`${this.words.result_label}: ${this.words['result_'+result.key]}`);
      this.briefLines=lines;this.querySelector('#sf-brief').value=lines.join('\n');
      this.querySelector('[data-personal-note]').hidden=true;
      this.querySelector('.sf-expect').hidden=this.answers.start==='mold';
      this.querySelector('[data-contact]').open=false;
      this.selectKit(result.key);
      this.save();this.track('result_view',{result:result.key});
      if(move)this.focus(this.querySelector('[data-result]'));
    }
    mediaTemplate(key){return this.querySelector(`template[data-media="${['miniature','scultura','verticali'].includes(key)?key:'miniature'}"]`);}
    setMedia(key){const target=this.querySelector('[data-aside-media]');target.querySelectorAll('video').forEach(v=>v.pause());target.replaceChildren();const tpl=this.mediaTemplate(key);if(tpl)target.append(tpl.content.cloneNode(true));}
    syncVariant(card){
      const option=card.querySelector('[data-variant]').selectedOptions[0];
      card.querySelector('[data-total-price]').textContent=option.dataset.price||'';
      const stock=card.querySelector('[data-stock]');stock.textContent=option.dataset.available==='true'?this.words.availability:this.words.sold;stock.dataset.available=option.dataset.available;
      const image=card.querySelector('.sf-product-photo');if(image && option.dataset.image){image.src=option.dataset.image;image.removeAttribute('srcset');}
      const link=card.querySelector('[data-product-link]');if(link)link.href=link.dataset.productUrl+'?variant='+option.value;
      card.querySelectorAll('[data-includes]').forEach(x=>x.hidden=!option.value || x.dataset.includes!==(option.dataset.full==='true'?'full':'base'));
      const button=card.querySelector('[data-buy]');button.disabled=option.dataset.available!=='true';button.textContent=option.value && button.disabled?this.words.sold:this.words.buy;
      card.querySelector('[data-cart-success]').hidden=true;
      card.querySelector('[data-cart-error]').hidden=true;
      if(this.started)this.save();
    }
    async cartRequest(path, payload) {
      const url = new URL(this.dataset.cart.replace(/\/$/, '') + path, location.origin);
      const response = await fetch(url, {method: payload ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', headers:{'Accept':'application/json','Content-Type':'application/json'}, ...(payload ? {body:JSON.stringify(payload)} : {})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
      return result;
    }
    async addWithGift(action, kitId, giftId) {
      let cart = await this.cartRequest('.js');
      const previousCodes = (cart.discount_codes || []).map(code => code.code);
      const gifts = cart.items.filter(item => item.properties?._sm_kit_gift === 'v1');
      if (gifts.length) cart = await this.cartRequest('/update.js', {updates:Object.fromEntries(gifts.map(item => [item.key,0]))});
      const operation = crypto.randomUUID();
      try {
        await this.cartRequest('/add.js', {items:[
          {id:kitId,quantity:1,properties:{_sm_gift_operation:operation}},
          {id:giftId,parent_id:kitId,quantity:1,properties:{_sm_kit_gift:'v1',_sm_gift_operation:operation,[this.dataset.locale==='fr'?'Cadeau':'Omaggio']:this.words.gift_property}}
        ]});
        const needsDiscount = giftId === this.querySelector('[data-gift-id]')?.dataset.giftId;
        const codes = previousCodes.filter(code => code.toUpperCase() !== this.dataset.giftCode.toUpperCase());
        if(needsDiscount) codes.push(this.dataset.giftCode);
        cart = await this.cartRequest('/update.js', {discount:[...new Set(codes)].join(',')});
        const added = cart.items.filter(item => item.properties?._sm_kit_gift === 'v1');
        if (added.length !== 1 || added[0].quantity !== 1 || added[0].final_line_price !== 0) {
          throw new Error(this.words.gift_discount_error);
        }
      } catch (error) {
        try {
          cart = await this.cartRequest('.js');
          const ours = cart.items.filter(item => item.properties?._sm_gift_operation === operation);
          if (ours.length) await this.cartRequest('/update.js', {updates:Object.fromEntries(ours.map(item => [item.key,0]))});
          await this.cartRequest('/update.js', {discount:previousCodes.join(',')});
        } catch (_) {
          throw new Error(this.words.gift_verify_error);
        }
        throw error;
      }
    }
    async addToCart(event,card){
      event.preventDefault();
      const form=event.currentTarget,button=card.querySelector('[data-buy]');
      if(button.disabled || !form.querySelector('[name=id]').value)return;
      if(this.busy)return;this.busy=true;
      this.querySelectorAll('[data-reset],[data-show-kit]').forEach(b=>b.disabled=true);
      card.dataset.adding='true';button.disabled=true;button.textContent=this.words.busy;
      const select=card.querySelector('[data-variant]');const payload=new FormData(form);select.disabled=true;
      const error=card.querySelector('[data-cart-error]');error.hidden=true;
      const choice=form.querySelector('[name=sm_gift_choice]:checked');
      const giftId=this.dataset.giftLive==='true' && this.dataset.giftCode?(choice?.value==='oil'?choice.dataset.giftId:choice?.value==='color'?form.querySelector('[data-gift-color]')?.value:null):null;
      payload.delete('sm_gift_choice');
      try{
        if(giftId){await this.addWithGift(form.action,String(payload.get('id')),String(giftId));}
        else{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:payload,headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw new Error(result.description||this.words.cart_error);}
        const cart=new URL(this.dataset.cart,location.origin);const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)cart.searchParams.set('preview_theme_id',preview);location.assign(cart.href);
        this.track('add_to_cart',{result:this.resultKey,variant:form.querySelector('[name=id]').value});
      }catch(e){error.textContent=e.message||this.words.cart_error;error.hidden=false;}
      finally{this.busy=false;this.querySelectorAll('[data-reset],[data-show-kit]').forEach(b=>b.disabled=false);card.dataset.adding='false';select.disabled=false;button.disabled=select.selectedOptions[0].dataset.available!=='true';button.textContent=button.disabled?this.words.sold:this.words.buy;}
    }
    reset(){
      this.querySelectorAll('video').forEach(v=>v.pause());
      this.answers={};this.index=0;this.resultKey='';this.started=false;
      this.querySelectorAll('input[type=radio]').forEach(x=>x.checked=false);
      this.querySelectorAll('[data-kit] form').forEach(f=>f.reset());
      this.querySelectorAll('[data-kit]').forEach(c=>{if(c.querySelector('form'))this.syncVariant(c);});
      this.querySelector('[data-workspace]').hidden=true;this.querySelector('[data-result]').hidden=true;this.querySelector('[data-intro]').hidden=false;
      try{sessionStorage.removeItem(this.storageKey);}catch{}
      this.recommendReason='';this.briefLines=[];this.querySelector('#sf-brief').value='';this.begin();
    }
    track(name,details={}){
      this.dispatchEvent(new CustomEvent('sm:finder',{bubbles:true,detail:{event:name,...details}}));
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() && Array.isArray(window.dataLayer))window.dataLayer.push({event:'sm_finder_'+name,...details});
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-kit-selector"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sm-kit-picker')) {
  customElements.define('sm-kit-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;
      this.abort = new AbortController();
      const opts = {signal: this.abort.signal};
      if (this.dataset.giftLive === 'true' || window.Shopify?.theme?.role === 'unpublished' || window.Shopify?.designMode) {
        this.querySelectorAll('.sm-gift-preview').forEach(gift => { gift.hidden = false; });
      }
      this.busy = false;
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.choose(i, true), opts);
        tab.addEventListener('keydown', event => {
          let next = i;
          if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault(); this.choose(next, true); this.tabs[next].focus();
        }, opts);
      });
      this.panels.forEach(panel => {
        panel.querySelector('[data-gift-color]')?.addEventListener('change', () => { panel.querySelector('[name="sm_gift_choice"][value="color"]').checked = true; }, opts);
        panel.querySelector('[data-variant]').addEventListener('change', () => this.sync(panel), opts);
        panel.querySelector('form').addEventListener('submit', event => this.submit(event, panel), opts);
      });
      this.sticky = this.querySelector('.sm-kit-sticky');
      this.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
        this.active.querySelector('form').requestSubmit();
      }, opts);
      this.editorSelect = event => {
        const idx = this.tabs.findIndex(tab => tab.dataset.block === event.detail.blockId);
        if (idx >= 0) this.choose(idx, false);
      };
      document.addEventListener('shopify:block:select', this.editorSelect, opts);
      const params = new URLSearchParams(location.search);
      const key = this.dataset.allowPreselect === 'true' ? params.get('kit') : null;
      let initial = key ? this.tabs.findIndex(tab => tab.dataset.key === key) : 0;
      if (initial < 0) initial = 0;
      this.dataset.ready = 'true';
      this.explicitProject = Boolean(key);
      this.choose(initial, false);
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.restorePurchaseControls();
      }, opts);
      if (this.sticky) {
        this.updateSticky = () => {
          const top = this.getBoundingClientRect().top;
          const button = this.active.querySelector('[type="submit"]').getBoundingClientRect();
          const visibleButton = button.top < innerHeight && button.bottom > 0;
          this.sticky.hidden = top > 100 || visibleButton || Boolean(window.Shopify?.designMode);
        };
        window.addEventListener('scroll', this.updateSticky, {...opts, passive:true});
        window.addEventListener('resize', this.updateSticky, opts);
        this.updateSticky();
      }
    }
    disconnectedCallback() { this.abort?.abort(); delete this.dataset.ready; }
    restorePurchaseControls() {
      this.busy = false;
      this.tabs.forEach(tab => { tab.disabled = false; });
      this.panels.forEach(panel => {
        panel.querySelector('[data-variant]').disabled = false;
        panel.querySelector('[type="submit"]').removeAttribute('aria-busy');
        this.sync(panel);
      });
      this.updateSticky?.();
    }
    choose(i, updateUrl) {
      if (this.busy) return;
      this.active = this.panels[i];
      this.tabs.forEach((tab, n) => {
        tab.setAttribute('aria-selected', String(n === i));
        tab.tabIndex = n === i ? 0 : -1;
        this.panels[n].hidden = n !== i;
      });
      this.sync(this.active);
      if (updateUrl && !window.Shopify?.designMode) {
        const url = new URL(location.href);
        url.searchParams.set('kit', this.tabs[i].dataset.key);
        history.replaceState({}, '', url);
      }
      this.updateSticky?.();
    }
    sync(panel) {
      const option = panel.querySelector('[data-variant]').selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      panel.querySelector('[data-price]').textContent = option.dataset.price;
      const compare = panel.querySelector('[data-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      const full = option.dataset.enhanced === 'true';
      panel.querySelector('[data-includes="base"]').hidden = full;
      panel.querySelector('[data-includes="full"]').hidden = !full;
      const img = panel.querySelector('.sm-kit-panel__image');
      if (img) {
        const src = full ? img.dataset.fullSrc : img.dataset.baseSrc;
        const small = full ? img.dataset.fullSmall : img.dataset.baseSmall;
        img.src = src; img.srcset = `${small} 480w, ${src} 900w`;
        img.alt = `${img.dataset.productTitle} — ${option.dataset.title}`;
      }
      panel.querySelector('[type="submit"]').disabled = !available || this.busy;
      panel.querySelector('[data-add-label]').textContent = available ? this.dataset.add : this.dataset.sold;
      panel.querySelector('.sm-kit-form__error').hidden = true;
      if (this.sticky && panel === this.active) {
        this.sticky.querySelector('.sm-kit-sticky__title').textContent = panel.dataset.title;
        this.sticky.querySelector('.sm-kit-sticky__price').textContent = option.dataset.price;
        this.sticky.querySelector('button').disabled = !available || this.busy;
        this.sticky.querySelector('button span').textContent = available ? this.dataset.add : this.dataset.sold;
      }
    }
    async cartRequest(path, payload) {
      const url = new URL(this.dataset.cart.replace(/\/$/, '') + path, location.origin);
      const response = await fetch(url, {method: payload ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', headers:{'Accept':'application/json','Content-Type':'application/json'}, ...(payload ? {body:JSON.stringify(payload)} : {})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
      return result;
    }
    async addWithGift(action, kitId, giftId) {
      // The discount must already exist in Shopify; a theme cannot set a price to zero.
      let cart = await this.cartRequest('.js');
      const previousCodes = (cart.discount_codes || []).map(code => code.code);
      const gifts = cart.items.filter(item => item.properties?._sm_kit_gift === 'v1');
      // Replace only our promotional lines; never remove a separately purchased product.
      if (gifts.length) cart = await this.cartRequest('/update.js', {updates:Object.fromEntries(gifts.map(item => [item.key,0]))});
      const operation = crypto.randomUUID();
      try {
        await this.cartRequest('/add.js', {items:[
          {id:kitId,quantity:1,properties:{_sm_gift_operation:operation}},
          {id:giftId,parent_id:kitId,quantity:1,properties:{_sm_kit_gift:'v1',_sm_gift_operation:operation,[this.dataset.giftProperty]:this.dataset.giftValue}}
        ]});
        const needsDiscount = giftId === this.querySelector('[data-gift-id]')?.dataset.giftId;
        const codes = previousCodes.filter(code => code.toUpperCase() !== this.dataset.giftCode.toUpperCase());
        if(needsDiscount) codes.push(this.dataset.giftCode);
        cart = await this.cartRequest('/update.js', {discount:[...new Set(codes)].join(',')});
        const added = cart.items.filter(item => item.properties?._sm_kit_gift === 'v1');
        if (added.length !== 1 || added[0].quantity !== 1 || added[0].final_line_price !== 0) {
          throw new Error(this.dataset.giftError);
        }
      } catch (error) {
        // Re-read keys because Shopify changes them when discounts change. Handle an
        // ambiguous network response without duplicating the kit on a second click.
        try {
          cart = await this.cartRequest('.js');
          const ours = cart.items.filter(item => item.properties?._sm_gift_operation === operation);
          if (ours.length) await this.cartRequest('/update.js', {updates:Object.fromEntries(ours.map(item => [item.key,0]))});
          await this.cartRequest('/update.js', {discount:previousCodes.join(',')});
        } catch (_) {
          throw new Error(this.dataset.cartError);
        }
        throw error;
      }
    }
    async submit(event, panel) {
      event.preventDefault();
      if (this.busy) return;
      const form = panel.querySelector('form');
      const select = panel.querySelector('[data-variant]');
      if (select.selectedOptions[0]?.dataset.available !== 'true') return;
      const data = new FormData(form);
      const giftChoice = form.querySelector('[name="sm_gift_choice"]:checked');
      const giftId = this.dataset.giftLive === 'true' && this.dataset.giftCode ? (giftChoice?.value === 'oil' ? giftChoice.dataset.giftId : giftChoice?.value === 'color' ? form.querySelector('[data-gift-color]')?.value : null) : null;
      data.delete('sm_gift_choice');
      this.busy = true;
      const button = panel.querySelector('[type="submit"]');
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      panel.querySelector('[data-add-label]').textContent = this.dataset.busy;
      this.tabs.forEach(tab => tab.disabled = true);
      select.disabled = true;
      if (this.sticky) {this.sticky.querySelector('button').disabled = true;this.sticky.querySelector('button span').textContent = this.dataset.busy;}
      const errorBox = panel.querySelector('.sm-kit-form__error');
      errorBox.hidden = true;
      try {
        const action = new URL(form.action, location.origin);
        action.pathname = action.pathname.replace(/\/add\/?$/, '/add.js');
        if (giftId) {
          await this.addWithGift(action, String(data.get('id')), String(giftId));
        } else {
          const response = await fetch(action, {method:'POST',body:data,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
        }
        const cart = new URL(this.dataset.cart, location.origin);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) cart.searchParams.set('preview_theme_id',preview);
        location.assign(cart.href);
      } catch (error) {
        this.busy = false;
        select.disabled = false;
        this.tabs.forEach(tab => tab.disabled = false);
        this.sync(panel);
        errorBox.textContent = error.message || this.dataset.error;
        errorBox.hidden = false;
        errorBox.scrollIntoView({block:'center',behavior:'smooth'});
      } finally {
        this.busy = false;
        select.disabled = false;
        this.tabs.forEach(tab => { tab.disabled = false; });
        button.removeAttribute('aria-busy');
        const available = select.selectedOptions[0]?.dataset.available === 'true';
        button.disabled = !available;
        panel.querySelector('[data-add-label]').textContent = available ? this.dataset.add : this.dataset.sold;
        if (this.sticky) {
          this.sticky.querySelector('button').disabled = !available;
          this.sticky.querySelector('button span').textContent = available ? this.dataset.add : this.dataset.sold;
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-project-videos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sm-project-films'))customElements.define('sm-project-films',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.querySelectorAll('article').forEach(card=>card.querySelector('video')?.setAttribute('aria-label',card.querySelector('h3').textContent));this.addEventListener('play',event=>{this.querySelectorAll('video').forEach(video=>{if(video!==event.target)video.pause()})},{capture:true,signal:this.abort.signal})}
 disconnectedCallback(){this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sm-review-slider')) customElements.define('sm-review-slider',class extends HTMLElement {
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.track=this.querySelector('.sm-reviews__grid');this.cards=[...this.querySelectorAll('.sm-review')];
  this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
  this.querySelector('.sm-review-nav').hidden=this.cards.length<2;
  this.prev.addEventListener('click',()=>this.move(-1),opts);this.next.addEventListener('click',()=>this.move(1),opts);
  this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update())},{...opts,passive:true});
  this.track.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.move(e.key==='ArrowLeft'?-1:1)}},opts);
  this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.sm-review');if(card)this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'instant'})},opts);
  this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
 }
 move(direction){this.track.scrollBy({left:direction*this.cards[0].getBoundingClientRect().width,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
 update(){const width=this.cards[0]?.getBoundingClientRect().width||1;const start=Math.round(this.track.scrollLeft/width)+1;const end=Math.min(this.cards.length,Math.floor((this.track.scrollLeft+this.track.clientWidth+2)/width));this.querySelector('[data-count]').textContent=`${start}–${Math.max(start,end)} / ${this.cards.length}`;this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2}
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-steps"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sm-short-film')) {
 customElements.define('sm-short-film', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   const opts = {signal:this.abort.signal}; const video=this.querySelector('video');
   video.addEventListener('play',()=>{ if(video.currentTime<113 || video.currentTime>=122) video.currentTime=113; },opts);
   video.addEventListener('timeupdate',()=>{ if(video.currentTime>=122 && !video.paused) video.pause(); },opts);
   this.querySelector('details').addEventListener('toggle',event=>{ if(!event.target.open) video.pause(); },opts);
  }
  disconnectedCallback() { this.abort?.abort(); }
 });
}

  } catch(e) { console.error(e); }
})();
})();
